module.exports = __webpack_public_path__ + "static/chestLogo-55e36413568960e9a3eb580b5885cba2.png";